import React from "react";
import { labelFor } from "./conversationIntel";

// The visible, removable record of a filter a panel raised. A list narrowed by a
// click made a screen away must say so where the list is, or the missing rows
// read as missing data.
const PanelFilterChip = ({ filter, onClear }) => {
  if (!filter?.value) return null;
  const shown = filter.kind === "topic" ? labelFor(filter.value) : filter.label || filter.value;
  // A gap selects its conversations by id, so the chip says what it selected
  // rather than implying the list was searched for those words.
  const prefix = filter.kind === "conversations" ? "From" : "Asked about";
  return (
    <button
      type="button"
      onClick={onClear}
      data-testid="panel-filter-chip"
      className="self-start inline-flex items-center gap-1.5 min-h-[44px] max-w-full px-2 rounded-md border border-[#C7E7FF] dark:border-blue-800 bg-[#EAF6FF] dark:bg-blue-900/30 text-xs font-medium text-[#1B5E86] dark:text-[#9BDBFF] transition-colors"
      title="Remove this filter"
    >
      <span className="truncate">{prefix}: {shown}</span>
      <span aria-hidden="true">×</span>
      <span className="sr-only">Remove filter</span>
    </button>
  );
};

export default PanelFilterChip;
